(function () {
  'use strict';

  /* Mobile menu */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Collection sort */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Product page: gallery + variant picker */
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var dataEl = document.getElementById('VariantData');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var priceEl = document.querySelector('[data-price]');
  var mainWrap = document.querySelector('[data-main-image]');
  var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
  var groups = form.querySelectorAll('[data-option-group]');
  var stockEl = document.querySelector('[data-stock]');
  var sticky = document.querySelector('[data-sticky]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAdd = document.querySelector('[data-sticky-add]');

  function swapImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
  }

  var thumbs = document.querySelectorAll('[data-thumb]');
  Array.prototype.forEach.call(thumbs, function (btn) {
    btn.addEventListener('click', function () {
      swapImage(btn.getAttribute('data-src'));
      Array.prototype.forEach.call(thumbs, function (t) { t.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  function selectedOptions() {
    return Array.prototype.map.call(groups, function (g) {
      var checked = g.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function renderPrice(v) {
    var html = '<span class="price">';
    if (v.compare) {
      html += '<span class="price-now is-sale">' + v.price + '</span> <s class="price-was">' + v.compare + '</s>';
    } else {
      html += '<span class="price-now">' + v.price + '</span>';
    }
    html += '</span>';
    if (priceEl) priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.innerHTML = html;
  }

  function setButtons(disabled, label) {
    addBtn.disabled = disabled;
    addBtn.textContent = label;
    if (stickyAdd) { stickyAdd.disabled = disabled; stickyAdd.textContent = label; }
  }

  function update() {
    var v = findVariant(selectedOptions());
    if (!v) {
      setButtons(true, 'Unavailable');
      if (stockEl) stockEl.hidden = true;
      return;
    }
    idInput.value = v.id;
    renderPrice(v);
    setButtons(!v.available, v.available ? 'Add to cart' : 'Sold out');
    if (stockEl) {
      if (v.stock > 0) { stockEl.textContent = 'Only ' + v.stock + ' left in stock'; stockEl.hidden = false; }
      else { stockEl.hidden = true; }
    }
    if (v.image) swapImage(v.image);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  Array.prototype.forEach.call(groups, function (g) {
    g.addEventListener('change', update);
  });

  /* Sticky add-to-cart bar: show once the main button scrolls out of view */
  if (sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    });
    io.observe(addBtn);
  }
})();
